import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './SideBarMobile.css'

const SideBarMobile = (
    { 
        menuItems=[],
        headerLogo,
        logo,
        userRole,
    }
) => {

    const [openSideBar, setOpenSideBar] = useState(false);
    const [openSubmenus, setOpenSubmenus] = useState({});
    const [activeItem, setActiveItem] = useState(null);

    const sidebarRef = useRef(null);
    const navigate = useNavigate();

    const toggleSubmenu = (id) => {
        setOpenSubmenus(prev => ({ ...prev, [id]: !prev[id] }));
    };

    // Handle click outside the sidebar
    const handleClickOutside = (event) => {
        if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
            setOpenSideBar(false);
        }
    };
    
    // Close Modal when click outside the sidebar
    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // Prevent scroll outside the sidebar
    useEffect(() => {
        const preventScrollOutside = (e) => {
            if (sidebarRef.current && !sidebarRef.current.contains(e.target)) {
                e.preventDefault(); // block scroll outside sidebar
            }
        };
        
        if (!sidebarRef){
            return;
        }

        if (openSideBar) {
            document.body.style.overflow = 'hidden';
            document.body.addEventListener('touchmove', preventScrollOutside, { passive: false }); 
        // } else {
        //     document.body.style.overflow = '';
        //     document.body.removeEventListener('touchmove', preventScrollOutside);
        }
        return () => {
            document.body.style.overflow = '';
            document.body.removeEventListener('touchmove', preventScrollOutside);
        };
    }, [openSideBar]);


    // When the user open the side bar, its scroll position should be from the start
    useEffect(() => {
        if(openSideBar && sidebarRef.current) {
            sidebarRef.current.scrollTop = 0; // reset the scroll position
        }
    }, [openSideBar]);

    const handleOpenSideBar = () => {
        setOpenSideBar(true);
    }

    const handleItemClick = (path, id) => {
        navigate(path);
        setActiveItem(id);
        setOpenSideBar(false);
    };

    return (
        <>  
            <button className="hamburger-btn" onClick={handleOpenSideBar}>
                {/* ☰ */}
                <i className="fa-solid fa-bars" style={{color: "#ffffff"}}></i>
                {headerLogo && <img src={headerLogo} alt="Header Logo" style={{width: '1.2rem'}}></img>}
            </button>

            {/* Overlay */}
            <div 
                className={`sidebar-overlay ${openSideBar ? 'show' : ''}`} 
                onClick={() => setOpenSideBar(false)}
            ></div>

            {/* Open Side Bar */}
            <div className={`sidebar-small ${openSideBar ? 'open' : ''}`} ref={sidebarRef}>
                <div className="sidebar-header-small">
                    <button className="sidebar-small-close-btn" onClick={() => setOpenSideBar(false)}>
                        X
                    </button>
                    {logo && <img src={logo} alt="Logo" className="sidebar-logo" />}
                </div>
                <nav className={`sidebar-nav-small`}>
                    <ul className="menu-list-small">
                        {menuItems.map(item => {
                            // Check if user role is allowed for this menu item
                            if (item.allowedRoles && !item.allowedRoles.includes(userRole)) return null;

                            return (
                            <li 
                                key={item.id} 
                                className="menu-item-small"
                            >
                                {item.submenu ? (
                                    <>
                                        <button
                                            className={`menu-button-small ${activeItem === item.id ? 'active' : ""}`}
                                            onClick={() => toggleSubmenu(item.id)}
                                            title={''}
                                        >
                                            <span className={`menu-icon-small`}>
                                                {item.icon}
                                            </span>
                                            <span className="menu-label-small">{item.label}</span>
                                            {/* {!isCollapsed && <FaChevronDown className="submenu-icon" />} */}
                                            <i
                                            className={`fa-solid fa-angle-down submenu-icon-small ${
                                                openSubmenus[item.id] ? 'open' : ''
                                            }`}
                                            ></i>

                                        </button>

                                        {/* Expanded: inline submenu */}
                                        {openSubmenus[item.id] && (
                                            <ul className="submenu-small">
                                                {item.submenu.map(sub => {
                                                // Check if user role is allowed for this sub menu item
                                                if (sub.allowedRoles && !sub.allowedRoles.includes(userRole)) return null;

                                                return (
                                                    <li key={sub.id}>
                                                        <button 
                                                            className={`menu-button-small ${activeItem === sub.id ? 'active' : ""}`}
                                                            onClick={() => handleItemClick(sub.path, sub.id)}
                                                        >
                                                            <span className="menu-icon-small">
                                                                {sub.icon}
                                                            </span>
                                                            <span className="menu-label-small">{sub.label}</span>
                                                        </button>
                                                    </li>
                                                );
                                                })}
                                            </ul>
                                        )}
                                    </>
                                ) : (
                                    <button 
                                        className={`menu-button-small ${activeItem === item.id ? 'active' : ""}`} 
                                        title={''} 
                                        onClick={() => handleItemClick(item.path, item.id)}
                                    >
                                        <span className={`menu-icon-small`}>
                                            {item.icon}
                                        </span>
                                        <span className="menu-label-small">{item.label}</span>
                                    </button>
                                )}
                            </li>

                            );
                        })}
                    </ul>
                </nav>
            </div>
        </>
    )
}

export default SideBarMobile;